
import React, {useEffect, useState} from 'react';


import {
} from '../../api/methodPayment.api';

import {connect} from 'react-redux';
import toastr from 'toastr';
import html2pdf from 'html2pdf.js';
import LoftyDropdownComponent from '../../components/loftydropdowncomponent';
import LoftyCountDown from '../../components/loftycountdown';
import LoftyCartCarousel from '../../components/loftycartcarousel';
import LoftyThreeCarousel from '../../components/loftythreecarousel';
import LoftyCarouselPlugin from '../../components/LoftyCarouselPlugin';
import LoftyLeaftMap from '../../components/loftyLeaftMaps';
import LoftyAnimatedParticleBackground from '../../components/loftyAnimatedParticleBackground';
import LoftyGoogleLoginComponent from '../../components/loftyGoogleLoginComponent';

import { addLoftyToken, deleteLoftytoken } from '../../actions/auth.actions';

import {customlistadodedestacadosderentatej45_67c86771a9c8dc86c67295b7, customlistadodeinmueblesenrentav25ht_67c868b2a9c8dc86c6729659 } from '../../api/inmuebles5x55o.api'

import './inmueblesenrentafeboj.scss';


// Hamburger
function loftyInitHam() {
  try {
  // eslint-disable-next-line no-restricted-globals
    window.addEventListener('click', (event) => {
      let originPointLeft = '';
      const comp = event.target.className;
      if (comp.includes('menu__btn') || comp.includes('span_middle') || comp.includes('span_before') || comp.includes('span_after')) {
        const res = Array.from(document.getElementsByClassName('menu__box'));
        const spanData = Array.from(document.getElementsByClassName('menu__btn'));
        const closeBtn = Array.from(document.getElementsByClassName('menu__close__btn'));
        spanData.forEach((item) => {
          originPointLeft = item.style.left;
        });
        res.forEach((item) => {
          item.style.left = '0px';
        });
        spanData.forEach((item) => {
          item.style.left = '-300px';
        });
        closeBtn.forEach((item) => {
          item.style.left = '10px';
        });
      } else {
        if (comp === 'menu__box') {
          return;
        }
        if (comp === 'linkshref') {
          return;
        }
        if (comp === 'menu__item') {
          return;
        }
        const res = Array.from(document.getElementsByClassName('menu__box'));
        const spanData = Array.from(document.getElementsByClassName('menu__btn'));
        const closeBtn = Array.from(document.getElementsByClassName('menu__close__btn'));
        res.forEach((item) => {
          item.style.left = '-300px';
        });
        spanData.forEach((item) => {
          item.style.left = originPointLeft;
        });
        closeBtn.forEach((item) => {
          item.style.left = '-100%';
        });
      }
    });
  } catch (error) {
    // console.log(error);
  }
}    
    






const Pinmueblesenrentafeboj = ({
  match,
  history,
  loftytoken,
  loftyuser,
  addLoftyUserApp,
  deleteLoftytokenApp,
  addLoftyTokenApp,
  
}) => {

	const [loftyres_67c86771a9c8dc86c67295b7_component_i5jul9, setloftyres_67c86771a9c8dc86c67295b7_component_i5jul9] = useState([]);
	const [loftyres_67c868b2a9c8dc86c6729659_component_img0q4, setloftyres_67c868b2a9c8dc86c6729659_component_img0q4] = useState([]);


useEffect(() => {
		const loftyHandleData = async () => {
		}
		loftyHandleData();
	}, []);

	useEffect(() => {
		const handleLoftyData = async () => {
			try {
				const responseLoftyApps = await customlistadodedestacadosderentatej45_67c86771a9c8dc86c67295b7({
				});
				setloftyres_67c86771a9c8dc86c67295b7_component_i5jul9(responseLoftyApps.data);
			} catch (loftyerror) {
			}
		}
		handleLoftyData();
	}, []);

	useEffect(() => {
		const handleLoftyData = async () => {
			try {
				const responseLoftyApps = await customlistadodeinmueblesenrentav25ht_67c868b2a9c8dc86c6729659({
				});
				setloftyres_67c868b2a9c8dc86c6729659_component_img0q4(responseLoftyApps.data);
			} catch (loftyerror) {
			}
		}
		handleLoftyData();
	}, []);



  
  setTimeout(() => { loftyInitHam(); }, 2000);

  
  

  
  return (
    <div id="id6772d9d5df08e4838cb89643" >

      <div id="iw4j" className="">
      
      <div id="i7iuy6" className="">
      
      <div id="ikooaf" className="">
      
      <span className="material-icons " id="iv5d9d">
        
      <span className="material-icons " id="iqcwn3">
        <>call</>
      </span>
      
      </span>
      
      <div className="" id="iwehdy">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="ijj06m">
        <>(+504) 9452-3409 </>
      </span>
      
      </div>
      
      <div className="" id="iws54s">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="i9drhg">
        <>(+504) 3292-8788</>
      </span>
      
      </div>
      
      </div>
      
      </div>
      
      <div id="ips2" className="">
      
      <img
        className=""
        id="ismeq"
        src="https://assetsprojects.s3.amazonaws.com/404ofwim56xoug0.png"
        alt="undefined"
      />
      
      <div id="ifvvzp" className="">
      
      <a
        target=""
        className=""
        id="inedox"
        href="/"
        type="button"
      >
        
    <div id="iclrrs" className="">
    <>Inicio</>
    </div>
    
      </a>
      
      <a
        target=""
        className=""
        id="iacjt4"
        href="/sobrenosotros"
        type="button"
      >
        
    <div id="ivmnu1" className="">
    <>Sobre Nosotros</>
    </div>
    
      </a>
      
        <LoftyDropdownComponent
          id="ik0zfc"
          className="gjs-dropdown-menu-container "
          childrenShow={
            <>
              <div id="iep5bk" className="gjs-dropdown-menu-trigger ">

      <span className="" id="ihsdhy">
        <>Inmuebles</>
      </span>
      </div>

            </>
          }
          childrenHover={
            <>
              <div id="iptn8k" className="gjs-dropdown-menu-content " style={{display: 'block'}}>

        <a
          target=""
          className=""
          id="iv90md"
          href="#"
        >
          
    <div id="i8xe7q" className="">
    <>En Renta</>
    </div>
    
        </a>
        
        <a
          target=""
          className=""
          id="izi3c5"
          href={`/inmueblesenventa`}
        >
          
    <div id="i4df7j" className="">
    <>En Venta</>
    </div>
    
        </a>
        </div>

            </>
          }
        />
        
      <a
        target=""
        className=""
        id="ih0w28"
        href="/contacto"
        type="button"
      >
        
    <div id="i89xkj" className="">
    <>Contacto</>
    </div>
    
      </a>
      
      </div>
      
      <div id="icq3pj" className="">
      
      <div id="" className="contentwrapperanimated ">
      
      <div id="" className="container_animated ">
      
      <label id="" className="menu__btn ">
      
      <span className="span_before " id="">
        
      </span>
      
      <span className="span_middle " id="">
        
      </span>
      
      <span className="span_after " id="">
        
      </span>
      
      </label>
      
      <label id="" className="menu__close__btn ">
      
      <span className="span__close__left " id="">
        
      </span>
      
      <span className="span__close__right " id="">
        
      </span>
      
      </label>
      
      <ul id="" className="menu__box ">
        
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="/"
        type=""
      >
        <>inicio</>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="/sobrenosotros"
        type=""
      >
        <>Sobre Nosotros</>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="/inmueblesenrenta"
        type=""
      >
        <>Inmuebles en Renta</>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="/inmueblesenventa"
        type=""
      >
        <>Inmuebles en Venta</>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="/contacto"
        type=""
      >
        <>Contacto</>
      </a>
      
      </li>
      
      </ul>
      
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      <div id="icx7ut" className="">
      
      <div className="" id="ij68c3">
        <>En Renta</>
      </div>
      
      </div>
      
      <div id="ipvnvk" className="">
      
      <div id="iizvzq" className="">
      
      <div className="" id="ii21mb">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="igaar5">
        <>Destacados de la semana</>
      </span>
      
      </div>
      
      </div>
      
      <div id="ip8fff" className="">
      
        <div id="i5jul9" className="">
        
            {
              loftyres_67c86771a9c8dc86c67295b7_component_i5jul9.map((loftyitem_67c86771a9c8dc86c67295b7_component_i5jul9) => (
                <div key={loftyitem_67c86771a9c8dc86c67295b7_component_i5jul9._id} className="" id="ieyn37">
                  
      <div
        id="ivaj3x"
        className="tarjeta "
        data-aos="fade-down"
        data-aos-duration="2000"
      >
      
        <img
          className=""
          id="i92iua"
          alt=""
          src={loftyitem_67c86771a9c8dc86c67295b7_component_i5jul9.loftyUrl}
        />
        
      <div id="if5lz2" className="titulo ">
      
        <div className="" id="igjb0j">
          
          <div className="" id="">
            {loftyitem_67c86771a9c8dc86c67295b7_component_i5jul9?.titulop4an9}
          </div>
          
        </div>
        
      </div>
      
      <div id="ih1kt4" className="">
      
        <a
          target=""
          className="button "
          id="ieb1bo"
          href={`/visualizacioninmueble/${loftyitem_67c86771a9c8dc86c67295b7_component_i5jul9._id}`}
        >
          
      <span className="" id="itultj">
        <>Visualizar detalles</>
      </span>
      
        </a>
        
      </div>
      
      </div>
      
                </div>
              ))
            }
            
        </div>
        
      </div>
      
      </div>
      
      <div id="if2bve" className="">
      
      <div id="ijuxs3" className="">
      
      <div className="" id="ies4dr">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="ih6c8d">
        <>Propiedades Recientes</>
      </span>
      
      </div>
      
      </div>
      
      <div id="i20udp" className="">
      
        <div id="img0q4" className="">
        
            {
              loftyres_67c868b2a9c8dc86c6729659_component_img0q4.map((loftyitem_67c868b2a9c8dc86c6729659_component_img0q4) => (
                <div key={loftyitem_67c868b2a9c8dc86c6729659_component_img0q4._id} className="" id="iffyuj">
                  
      <div
        id="idk96l"
        className="tarjeta "
        data-aos="fade-down"
        data-aos-duration="2000"
      >
      
        <img
          className=""
          id="iq8px1"
          alt=""
          src={loftyitem_67c868b2a9c8dc86c6729659_component_img0q4.loftyUrl}
        />
        
      <div id="ikyn79" className="">
      
        <div className="" id="ibe6df">
          
          <div className="" id="">
            {loftyitem_67c868b2a9c8dc86c6729659_component_img0q4?.titulop4an9}
          </div>
          
        </div>
        
      </div>
      
      <div id="i4vpvj" className="">
      
        <a
          target=""
          className="button "
          id="iu1iis"
          href={`/visualizacioninmueble/${loftyitem_67c868b2a9c8dc86c6729659_component_img0q4._id}`}
        >
          
      <span className="" id="ixo642">
        <>Visualizar detalles</>
      </span>
      
        </a>
        
      </div>
      
      </div>
      
                </div>
              ))
            }
            
        </div>
        
      </div>
      
      </div>
      
      <div id="ikukgf" className="">
      
      <div id="i1qiq6" className="">
      
      </div>
      
      <div id="i28lhh" className="">
      
      <div id="inehij" className="">
      
      <div className="" id="i2p8fx">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="i6lug4">
        <>¿Planea arrendar o vender su inmueble?</>
      </span>
      
      </div>
      
      </div>
      
        <a
          target=""
          className=""
          id="ivq6og"
          href="/contacto"
        >
          
      <span className="" id="inw7ed">
        <>Contáctanos</>
      </span>
      
        </a>
        
      </div>
      
      </div>
      
      <div id="il4d9o" className="">
      
      <div id="ioigc7" className="">
      
      <div id="ir2su1" className="">
      
      <img
        className=""
        id="imr6xn"
        src="https://assetsprojects.s3.amazonaws.com/404ofwim56z3fz2.png"
        alt="undefined"
      />
      
      </div>
      
      <div id="iip0hj" className="">
      
      <div id="icdzzf" className="">
      
      <div id="itmdc" className="">
      
      <a
        target=""
        className=""
        id="i2aqf"
        href="/"
        type="button"
      >
        
    <div id="i2g1w" className="">
    <>Inicio</>
    </div>
    
      </a>
      
      <a
        target=""
        className=""
        id="iwu1w"
        href="/sobrenosotros"
        type="button"
      >
        
    <div id="ib1qi" className="">
    <>Sobre Nosotros</>
    </div>
    
      </a>
      
      <a
        target=""
        className=""
        id="ig1at"
        href="/contacto"
        type="button"
      >
        
    <div id="isq53" className="">
    <>Contacto</>
    </div>
    
      </a>
      
      </div>
      
      <div id="inxorr" className="">
      
      <img
        className=""
        id="iib493"
        src="https://assetsprojects.s3.amazonaws.com/404ofwim56z589z.png"
        alt="undefined"
      />
      
      </div>
      
      <div className="" id="i9jwhn">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="ilrddl">
        <>Teléfono: +504 33445633 
Correo electrónico: informacion@grupodor.com 
Dirección: Colonia Universidad, 24 calle, 9 avenida, Plaza Bulevares, San Pedro Sula, Cortés, Honduras C.A.
</>
      </span>
      
      </div>
      
      <div id="ikrieu" className="">
      
        <a
          target="_blank"
          className=""
          id="iugvxb"
          href="https://www.facebook.com/DORInmobiliariaHN/?_rdr"
        >
          
      <span className="" id="ifk2kr">
        <>Facebook</>
      </span>
      
        </a>
        
        <a
          target="_blank"
          className=""
          id="iewo54"
          href="https://www.instagram.com/dorinmobiliaria"
        >
          
      <span className="" id="ig11q1">
        <>Instagram</>
      </span>
      
        </a>
        
        <a
          target="_blank"
          className=""
          id="ixgr5i"
          href="https://www.linkedin.com/company/dor-inmobiliaria/"
        >
          
      <span className="" id="iz2xzh">
        <>LinkedIn</>
      </span>
      
        </a>
        
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      <div id="imier2" className="">
      
      <div id="i50ldy" className="">
      
      </div>
      
      <div id="igphyo" className="">
      
      <div className="" id="i1gmf4">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="iy1e52">
        <>DOR © 2024. Todos los derechos reservados</>
      </span>
      
      </div>
      
      <div className="" id="ids74n">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="izx0i8">
        <>Términos de uso</>
      </span>
      
      </div>
      
      <div className="" id="i6pgi9">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="itfy23">
        <>Políticas de privaciad</>
      </span>
      
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      </div>
      
</div>
  );
}

const mapStateToProps = (state) => state.auth;

const mapDispatchToProps = (dispatch) => ({
 addLoftyTokenApp: (data) => dispatch(addLoftyToken(data)),
 deleteLoftytokenApp: () => dispatch(deleteLoftytoken()),
});


export default connect(mapStateToProps, mapDispatchToProps)(Pinmueblesenrentafeboj);
  